<template>
  <div class="el-main-1" style="background-color:ghostwhite;margin-top: 20px;">
    <el-breadcrumb separator="/"  style="height:60px;margin-left: 10px; font-size:20px; display: flex ;align-items: center;">
      <el-breadcrumb-item ><a class=""  v-on:click ="routeFunc" >首页</a></el-breadcrumb-item>
      <el-breadcrumb-item >知识题库</el-breadcrumb-item>
      <el-breadcrumb-item >全部</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div style="height:450px">
      <el-row>
        <el-col style="padding: 10px; height: 240px;" :xs="24" :sm="24" :md="12" :lg="6" :xl="6"  v-for = "(item, index ) in tableData" :key = "index" >
          <div style="background-color:#fff;  cursor: pointer; height: 230px">
            <el-image 
            style="width: 100%; height: 200px ; border-radius: 10px;"
            :src="item.coverImage"
            :fit="'fit'" @click="goSelfTest(item.id)"></el-image>
            <el-tag type="warning"  @click="goSelfTest(item.id)" class="tzgg-ul" style="width:100%;font-size: 18px;">
                {{ item.moduleName }}
            </el-tag>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height : 80px">
      <el-pagination
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount" style="margin-top:50px;">
    </el-pagination>

    </div>

    <el-dialog :visible.sync="dialogVisual.viewQbVisual" fullscreen  v-on:close ="clearViewQbOneDetail" >
        <el-col :span="6" style="">
          <el-card style="height:calc(86vh - 19px);margin-top: 10px; overflow:auto; text-align: left;">
            <div  class="clearfix">
              <el-tag type ="mini">
                {{ viewQbOneDetail.moduleName }}
              </el-tag>
              <span>
                一共{{ viewQbOneDetail.totalCount }}题
              </span>
            </div>
            <div style="margin-top: 10px;text-align: left;">
              <el-progress type="circle" :format="funcAnswered" :percentage="viewQbOneDetail.learnPer" :width="70"></el-progress>
              <el-progress type="circle" :format="funcOk" :percentage="viewQbOneDetail.learnOkPer" :width="70" style="margin-left:20px"></el-progress>
            </div>     
            <div v-for = "(item,index) in viewQbOneDetail.qtList" :key="index" style="margin-top:5px">
              <el-tag type ="mini"> {{item.answerCheckType}}</el-tag>
              <div>
                <div style="margin-top : 5px">一共:{{item.count}}题 </div>
                <div style="margin-top : 5px">已学:{{item.learnCount}}题 </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="18">
          <el-card style="height:calc(86vh - 18px);text-align:left ; margin-top:10px;margin-left:20px; overflow:auto;">
            <div slot="header" class="clearfix">
              <el-tag type="warning">{{ qbView.uniqNo }}</el-tag>
              <el-tag style ="margin-left: 10px;">{{ qbView.moduleName }}</el-tag>
              <el-tag type="success">{{  qbView.answerCheckType }}</el-tag>
              <el-tag :type=" qbView.selected ? 'success' : 'warning'">{{  qbView.selected ? '已作答':'未作答' }}</el-tag>
              <el-button  type="primary"  v-if ="qbView.selected"   style="el-icon--right" @click="recordOneSchedule()" size = "small" icon="">设置为书签 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button  type="danger"  v-if ="qbView.selected && !qbView.resultOk"   style="el-icon--right" @click="recordErrorQb()" size = "small" icon="">加入错题集 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </div>
            <div style ="margin-top: 10px;" >
              <el-tag type="warning">问题</el-tag>
              <span style ="margin-left: 10px;">{{qbView.question }}</span>
            </div>
            <div style ="margin-top: 10px;" v-if = "qbView.imageUrlList.length > 0 "> 
              <el-tag type="warning" style="padding-top: 0px">图片</el-tag>
              <el-badge  v-for="(item,index) in qbView.imageUrlList" :key = "index"  :value="index + 1" class="item">
                <el-image   
                  style="width: 100px; height: 100px;margin-left: 10px; "
                  :src="item.url"
                  :fit="fit">
                </el-image>
              </el-badge>
            </div>
            <div style ="margin-top: 10px;">
              <el-checkbox-group v-model="qbView.checkedOptList" >
                <el-tag type="warning">选项</el-tag>
                <el-checkbox style ="margin-left: 10px;"  :disabled = "qbView.selected" v-for="(opt , index ) in qbView.optionValueArr" :label="String.fromCharCode(65 + index)" :key="opt">{{opt}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div style ="margin-top: 10px;" v-if ="qbView.selected" >
              <el-tag type="warning">我的答案</el-tag>
              <span style ="margin-left: 10px;">{{qbView.learnAnswer }}</span>
              <el-button  size="mini"  :type="qbView.resultOk ? 'success':'danger'"
               :icon="qbView.resultOk ? 'el-icon-check': 'el-icon-close'" circle></el-button>
            </div>
            <div style ="margin-top: 10px;">
              <el-tag type="warning">操作</el-tag>
              <el-button v-if ="!qbView.selected"   style ="margin-left:10px;" type="primary"   @click="submitAnswer()"  size = "small">提交答案<i class="el-icon-upload el-icon--right"></i></el-button>
              <el-button  type="primary"  v-if ="qbView.selected"  size = "small" @click = "seeAnswer()" icon="el-icon-search">查看答案</el-button>
              <el-button  type="primary"   size = "small" icon="el-icon-arrow-left"  @click = "learnNextQb2(false)" >上一题</el-button>
              <el-button  type="primary"   style="el-icon--right"  size = "small"  @click = "learnNextQb2(true)" icon="">下一题 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
              <el-button  type="primary"   style="el-icon--right"  size = "small"  @click = "leanNextUndoQb()" icon="">未学习 <i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </div >
            <div style ="margin-top: 10px;"  v-if ="qbView.selected && qbView.seeAnswer" >
              <el-tag type="warning">答案</el-tag>
              <span style ="margin-left: 10px;" > {{qbView.answer }}</span>
            </div >
            <div style ="margin-top: 10px;"  v-if ="qbView.selected && qbView.seeAnswer">
              <el-tag type="warning"  >解析</el-tag>
              <span style ="margin-left: 10px;"> {{qbView.analysis }}</span>
            </div>
          </el-card>
        </el-col>
    </el-dialog>
  </div>
</template>                        
<script>
// 引入组件
import axios from  '@/api/axiosConfig'
import {MESSAGE_DURATION,fileType} from  '@/api/constant'
import SERVICE_URL  from  '@/api/url'
export default {
  name : 'pc_qm',
  data() {
    return {
      tableData:[],
      pager:{
        totalCount:0,
        pageSize : 8                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
      },
      viewQbOneDetail: {
        moduleId :'',
        moduleName:'',
        totalCount : '',
        learnPer : 0,
        learnOkPer : 0,
        learnCount :'',
        learnOkCount : '',
        qtList :[]
      },
      qbView : {
        checkedOptList:[],
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        id: '',
        learnAnswer :'',
        learnTime :'',
        answerCheckType :'',
        selected : false,
        resultOk: false,
        seeAnswer:false,
        imageUrlList :[]
      },
      dialogVisual :{
        viewQbVisual :false
      }
    }
  },
  methods : {
    funcAnswered(percentage){
      return '已答' + percentage +'%'
    },
    funcOk(percentage){
      return '正确' + percentage +'%'
    },
    seeAnswer(){
      this.qbView.seeAnswer = true
    },
    goSelfTest(id){
      this.dialogVisual.viewQbVisual = true
      this.viewQbOneDetail.moduleId = id
      setTimeout(()=>{this.qbLearnOneModuleSum(id)},200)
      setTimeout(()=>{this.leanNextQb(id,0,true)},200)
    },
    submitAnswer(){
      if(this.qbView.checkedOptList.length == 0){
        this.$message({
          showClose: true,
          message: '请选择答案！',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let answer = this.qbView.checkedOptList.sort().join("") 
      let url = "/bc/exa/qb/leanCommitAnswerQb"
      let dat0 = { qbId:this.qbView.id, answer }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.qbView.selected = true
          this.qbView.learnAnswer = answer
          if(answer == this.qbView.answer ){
            this.qbView.resultOk = true
          }else {
            this.qbView.resultOk = false
          }
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION
        })
      })
    },

    qbLearnOneModuleSum(id){
      let url = "/bc/exa/qb/qbLearnOneModuleSum"
      let dat0 = { id }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.viewQbOneDetail.moduleName = dat.moduleName
          this.viewQbOneDetail.totalCount = dat.totalCount
          this.viewQbOneDetail.learnOkCount = dat.learnOkCount
          this.viewQbOneDetail.learnCount = dat.learnCount
          if(dat.totalCount != 0 ){
            this.viewQbOneDetail.learnOkPer =  Math.floor( 100 *  dat.learnOkCount /  dat.totalCount )
            this.viewQbOneDetail.learnPer = Math.floor( 100 * dat.learnCount / dat.totalCount )
          }
          if(dat.qtList != null && dat.qtList.length != 0){
            dat.qtList.forEach(t=>{
              this.viewQbOneDetail.qtList.push({
                count:t.count,
                learnCount:t.learnCount,
                learnOkCount:t.learnOkCount,
                answerCheckType:t.answerCheckType
              })
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION
        })
      })
    },
    learnNextQb2(asc){
      this.leanNextQb( this.viewQbOneDetail.moduleId, this.qbView.id,asc)
    },
    leanNextQb(id,curQbId,asc){
      let url = "/bc/exa/qb/leanNextQb"
      let dat0 = {moduleId:id, curQbId, asc }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbView.analysis = dat.analysis
          this.qbView.id = dat.id
          this.qbView.answer = dat.answer
          this.qbView.question = dat.question 
          this.qbView.moduleName = dat.moduleName
          this.qbView.uniqNo = dat.uniqNo
          this.qbView.answerCheckType =dat.answerCheckType
          this.qbView.learnAnswer = dat.learnAnswer
          this.qbView.selected =  dat.selected
          this.qbView.resultOk =  dat.resultOk
          this.qbView.learnTime = dat.learnTime
          this.qbView.imageUrlList.splice(0)
          this.qbView.optionValueArr.splice(0)
          this.qbView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },
    recordOneSchedule(){
      let url = "/bc/exa/qb/recordOneSchedule"
      let dat0 = {moduleId:this.viewQbOneDetail.moduleId, qbId:this.qbView.id }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入书签成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })
    },
    recordErrorQb(){
      if( !this.qbView.selected){
        this.$message({
          showClose: true,
          message: '该题目未作答，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }

      if( this.qbView.resultOk){
        this.$message({
          showClose: true,
          message: '您的答案是正确的，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let url = "/bc/exa/error/addError"
      let dat0 = { qbId:this.qbView.id,errorAnswer:this.qbView.learnAnswer }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入错题集成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })

    },
    leanNextUndoQb(){
      if(!this.qbView.selected) {
        this.$message({
          showClose: true,
          message: '当前题目未作答',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let url = "/bc/exa/qb/leanNextUndoQb"
      let dat0 = {id: this.viewQbOneDetail.moduleId }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          this.qbView.analysis = dat.analysis
          this.qbView.id = dat.id
          this.qbView.answer = dat.answer
          this.qbView.question = dat.question 
          this.qbView.moduleName = dat.moduleName
          this.qbView.uniqNo = dat.uniqNo
          this.qbView.answerCheckType =dat.answerCheckType
          this.qbView.learnAnswer = dat.learnAnswer
          this.qbView.selected =  dat.selected
          this.qbView.resultOk =  dat.resultOk
          this.qbView.learnTime = dat.learnTime
          this.qbView.imageUrlList.splice(0)
          this.qbView.optionValueArr.splice(0)
          this.qbView.checkedOptList.splice(0)
          for(let i = 0; i< 5; i++){
            let v =  dat['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
          }
          for(let i = 0; i< dat.countImage; i++){
            this.qbView.imageUrlList.push({name: dat.id , url : dat['fileUrl'+ (i+1)]})
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
        showClose: true,
        message: err.message,
        type: 'error',
        duration: MESSAGE_DURATION
        })
      })
    },

    clearViewQbOneDetail(){
       this.viewQbOneDetail.learnOkPer = 0
       this.viewQbOneDetail.learnPer = 0
       this.viewQbOneDetail.moduleId = ''
       this.viewQbOneDetail.moduleName = ''
       this.viewQbOneDetail.totalCount  = ''
       this.viewQbOneDetail.learnCount  = ''
       this.viewQbOneDetail.learnOkCount  = ''
       this.viewQbOneDetail.qtList.splice(0)
       this.clearViewQbForm()
    },
    
    clearViewQbForm(){
      this.dialogVisual.viewQbVisual = false
      this.qbView.analysis = ''
      this.qbView.answer = ''
      this.qbView.question = ''
      this.qbView.moduleName = ''
      this.qbView.uniqNo = ''
      this.qbView.answerCheckType = ''
      this.qbView.optionValueArr.splice(0)
      this.qbView.imageUrlList.splice(0)
      this.qbView.checkedOptList.splice(0)
      this.qbView.learnAnswer = ''
      this.qbView.id = ''
    },
    routeFunc(){
      window.parent.postMessage({
        data: "1",
      }, '*');
    },
    routeFuncDetail( id){
      let left0 =  (window.screen.availWidth-10-1000)/2
      let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=1000,height=1000,left=${left0},top=100`;
      window.open(SERVICE_URL + "/#/pc_editor_view/" +id +"?fileType=" + fileType.NOTICE_FILE,"test",params0);
    },
    handleCurrentChange(val){
      this.qmListLoad(val);
    },
    qmListLoad(pageNo){
      let url = "/bc/exa/qm/qmPage"
      let dat0 = {
          pageSize: 8,
          pageNo,
          active:1,
          adminInfInvoke: false
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.tableData = [];
            dat.data.forEach(t=>this.tableData.push(t))
            this.pager.totalCount = dat.totalDataCount;
          } else {
            this.$message({
              showClose: true,
              message: '未查询到安全知识信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
  },
  created(){
    setTimeout(()=>{ this.qmListLoad(1) },200)
  },
  components: {
  }
}
</script>
  
<style lang="less" scoped>

.el-main-1 {
  width: 100%;
  margin-top:0px;
  padding: auto;
  // background-color:rgb(130, 20, 20);
  // background-color:#f9fafc;
  color: #333;
  margin: auto;
  text-align: center;
  height: 99%;
  overflow:auto;
}

.el-row {
  padding: auto;
  margin: auto;

  width: 100%;
  font-size: large;
  text-align: center;
  .el-col{

    height: 300px;
  }
}

.el-divider--horizontal{
  background-color: #2577d5;
  height: 2px;
  width: 100%;
  margin: auto;
  width: 100%
}

</style>
  


// WEBPACK FOOTER //
// src/pc_pages/pc_component/pc_qm.vue